const items = [
  "Bespoke Trade Design",
  "Local SEO Dominance",
  "High-Speed Lead Funnels",
  "Automated Quote Booking",
  "Brand Monogram Identity",
  "Obsidian Craft Standard",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {items.map((item) => (
      <div key={item} className="flex items-center">
        <span className="font-serif italic text-2xl sm:text-3xl text-zinc-500 px-8 whitespace-nowrap">{item}</span>
        <span className="w-2 h-2 rotate-45 bg-gold/60 shrink-0" />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="agency-marquee-ribbon" className="relative py-8 border-y gold-border-subtle overflow-hidden bg-surface/40">
      <div className="marquee-track">
        <Row />
        <Row />
      </div>
    </div>
  );
}
